export default __webpack_public_path__ + "static/4-a905f6b449e4027f2454bb335fff1164.png";